/**
 * Section divider inside the sidebar. Renders as a labelled block when the
 * sidebar is expanded, or as a slim horizontal rule on the collapsed rail.
 */
export default function SidebarDivider({ item, collapsed }) {
  if (collapsed) {
    return (
      <div
        className="my-2 mx-3 border-t border-white/[0.06]"
        data-testid={`sidebar-divider-${item.key}`}
      />
    );
  }
  return (
    <div className="pt-3 pb-1 px-3" data-testid={`sidebar-divider-${item.key}`}>
      <div className="text-[10px] uppercase tracking-widest text-slate-600">{item.label}</div>
    </div>
  );
}
